import React, { useState } from 'react';
import './AddStudyMaterialToolTip.css';

function AddStudyMaterialToolTip({ case2, name, description, scheduledDate, children, buttonfunction }) {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setTooltipPosition({ x: e.clientX, y: e.clientY });
  };

  const formatScheduledDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
  };

  const formattedScheduledDate = formatScheduledDate(scheduledDate);
  const tooltipContent = (
    <div className="tooltip-content">
      {case2 && <span className='toolTipFontSize'>{case2}</span>}
      <span className='toolTipFontSize'>{name}</span>
      <span className='toolTipFontSizeDescription'>{description}</span>
      {scheduledDate && <span className='toolTipFontSizeScheduled'> {buttonfunction === "Assessment" ? "Scheduled On" : "Deadline"} |  {formattedScheduledDate}</span>}
    </div>
  );

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      onMouseMove={handleMouseMove}
    >
      {tooltipVisible &&
        <div
          className="tooltiptext"
          style={{ top: tooltipPosition.y + 10, left: tooltipPosition.x + 10 }}
        >
          {tooltipContent}
        </div>
      }
      {children}
    </div>
  );
}

export default AddStudyMaterialToolTip;
